// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LHo4","newExpiryDate":"styles_newExpiryDate__3Ol5j","footer":"styles_footer__10cnX"};